import React from 'react'

import './Contact.scss';

export default function Contact() {
  return (
    <div className="contact">
      <div className="container">
        <h1>Get in touch</h1>
        <p>I am currently open for any junior/graduate software developer/web developer position, please feel free to contact me. </p>
        <address>
          Mobile: 0414419954 <br />
          Email: Gemju.s1@gmail.com
        </address>
        <a href="mailto:gemju.s1@gmail.com" className='btn'>Contact Me</a>
      </div>
    </div>
  )
}
